// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/stylesheets/body/assetstores.styl
// module id = 240
// module chunks = 0